var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProduct = function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.652 223.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "product_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h17.689v18.229H0z",
    "data-name": "Rectangle 2858"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h13.775v14.169H0z",
    "data-name": "Rectangle 2859"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h17.008v17.495H0z",
    "data-name": "Rectangle 2860"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h27.89v28.735H0z",
    "data-name": "Rectangle 2861"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "product_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h72.644v37.394H0z",
    "data-name": "Rectangle 2863"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "product_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10035"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "product_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.857 189.526a81.6 81.6 0 0 1-16.318-1.644 80.6 80.6 0 0 1-15.198-4.718 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377C32.383 66.843 38.802 55.51 46.384 45.41c3.967-5.284 8.198-10.152 12.577-14.47 4.607-4.542 9.382-8.478 14.193-11.697 5.09-3.406 10.26-6.036 15.367-7.816 5.415-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.384 16.889 12.652 12.652 22.266 23.309 29.392 32.58 3.542 4.607 6.481 8.872 8.988 13.039 2.423 4.03 4.38 7.866 5.983 11.73 6.247 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.3-7.742 3.134-17.116 5.271-28.657 6.533-9.037.988-19.514 1.448-32.971 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M104.628 9.082c-5.216 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.253 7.76-4.785 3.201-9.535 7.117-14.12 11.638-4.361 4.3-8.576 9.15-12.528 14.413-7.556 10.065-13.953 21.36-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.917 1.635 16.218a80 80 0 0 0 4.688 15.102 80.5 80.5 0 0 0 7.419 13.668 81 81 0 0 0 9.826 11.91 81 81 0 0 0 11.91 9.826 80.5 80.5 0 0 0 13.667 7.418 80 80 0 0 0 15.103 4.689 81 81 0 0 0 16.218 1.634c13.438 0 23.898-.459 32.917-1.445 11.494-1.257 20.824-3.383 28.524-6.5 4.255-1.723 8.051-3.783 11.282-6.123 3.416-2.473 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.422 1.976-9.393 1.976-14.773 0-3.659.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.655-5.95-11.663-2.496-4.15-5.426-8.4-8.955-12.993-7.113-9.253-16.713-19.894-29.35-32.53-11.11-11.11-23.231-16.743-36.03-16.743m0-1c12.206 0 24.704 5.002 36.737 17.035 55.474 55.474 50.38 70.136 50.38 115.128s-44.896 49.781-89.888 49.781-81.466-36.473-81.466-81.465c0-35.233 40.173-100.479 84.237-100.479"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#product_svg__a)",
    transform: "translate(.001 .003)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9666"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9736"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9664"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9737"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9650",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9649"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_svg__b)",
    "data-name": "Group 9648",
    transform: "translate(105.469 88.091)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "m3.767 16.249 1.447-1.072a.4.4 0 0 1 .415-.033q.255.131.525.242a7 7 0 0 0 1.01.329.39.39 0 0 1 .3.326l.286 1.86a.387.387 0 0 0 .411.329l1.717-.113a.38.38 0 0 0 .356-.363l.073-1.731a.384.384 0 0 1 .288-.359 7 7 0 0 0 2-.907.4.4 0 0 1 .481.039l.778.711a.4.4 0 0 0 .529.005l1.278-1.133a.4.4 0 0 0 .068-.076.38.38 0 0 0-.011-.447l-.8-1.081-.2-.263a7 7 0 0 0 .433-.871 7 7 0 0 0 .381-1.241.38.38 0 0 1 .319-.3l1.5-.228a.4.4 0 0 0 .337-.42l-.086-1.312-.026-.376a.4.4 0 0 0-.384-.377l-1.447-.062a.38.38 0 0 1-.358-.275 7 7 0 0 0-.574-1.361q-.027-.057-.059-.109a.2.2 0 0 1-.019-.037.39.39 0 0 1 .071-.43l1.152-1.266a.3.3 0 0 0 .036-.045.4.4 0 0 0-.031-.482l-1.128-1.276a.4.4 0 0 0-.533-.056l-1.511 1.11a.38.38 0 0 1-.435.019 7 7 0 0 0-.954-.48q-.267-.11-.538-.2a.4.4 0 0 1-.276-.324L10.313.325a.386.386 0 0 0-.407-.327l-1.7.114a.4.4 0 0 0-.378.386l-.058 1.37a.4.4 0 0 1-.317.373 7 7 0 0 0-2.011.729.39.39 0 0 1-.46-.054l-1.14-1.039a.41.41 0 0 0-.542 0L2.028 3a.39.39 0 0 0-.055.526l.046.064.93 1.256a.4.4 0 0 1 .015.454A7 7 0 0 0 2.4 6.385a7 7 0 0 0-.222.621.39.39 0 0 1-.316.276l-1.521.232a.4.4 0 0 0-.343.426l.113 1.691a.4.4 0 0 0 .034.135.4.4 0 0 0 .345.236l1.156.047a.4.4 0 0 1 .333.212.4.4 0 0 1 .038.1 6.9 6.9 0 0 0 1.057 2.522.39.39 0 0 1 .007.428.4.4 0 0 1-.041.053l-.934 1.024a.4.4 0 0 0 0 .527l.026.03 1.1 1.245a.4.4 0 0 0 .54.055m7.352-10.139a4.6 4.6 0 0 1 .625.593 3.63 3.63 0 0 1 .762 1.829c0 .061.007.122.01.183a3.757 3.757 0 0 1-7.415 1.092 2.5 2.5 0 0 1-.051-.361 4.3 4.3 0 0 1 .149-1.445 3.73 3.73 0 0 1 5.92-1.89",
    "data-name": "Path 15288"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9653",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9652"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_svg__c)",
    "data-name": "Group 9651",
    transform: "translate(118.662 74.477)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "m2.108 12.044 1.242-.673a.31.31 0 0 1 .326.02q.184.13.381.246a5 5 0 0 0 .748.367.31.31 0 0 1 .2.286l.017 1.476a.3.3 0 0 0 .283.3l1.346.1a.3.3 0 0 0 .317-.243l.248-1.337a.3.3 0 0 1 .264-.247 5.5 5.5 0 0 0 1.651-.484.31.31 0 0 1 .37.083l.526.638a.314.314 0 0 0 .41.063l1.118-.739a.3.3 0 0 0 .061-.052.3.3 0 0 0 .04-.348l-.5-.928-.123-.226a5.4 5.4 0 0 0 .432-.629 5.5 5.5 0 0 0 .433-.922.3.3 0 0 1 .281-.2l1.189-.012a.31.31 0 0 0 .308-.289l.078-1.029.021-.3a.316.316 0 0 0-.257-.335l-1.117-.208a.3.3 0 0 1-.248-.253 5.4 5.4 0 0 0-.3-1.12 1 1 0 0 0-.034-.091l-.01-.031a.31.31 0 0 1 .1-.326l1.035-.856a.2.2 0 0 0 .032-.031.31.31 0 0 0 .029-.378L12.27 2.22a.31.31 0 0 0-.408-.1l-1.3.7a.3.3 0 0 1-.34-.034 5.5 5.5 0 0 0-.688-.478q-.2-.115-.4-.212a.32.32 0 0 1-.179-.282L8.939.395a.3.3 0 0 0-.28-.3l-1.332-.1a.317.317 0 0 0-.336.258l-.2 1.058a.31.31 0 0 1-.287.255 5.4 5.4 0 0 0-1.643.345.31.31 0 0 1-.352-.092L3.738.886a.32.32 0 0 0-.421-.063l-1.112.732a.306.306 0 0 0-.1.4l.029.054.583 1.078a.31.31 0 0 1-.039.355 5.4 5.4 0 0 0-.558.781c-.088.15-.167.3-.241.458a.31.31 0 0 1-.275.18l-1.208.012a.317.317 0 0 0-.314.293l-.1 1.326a.3.3 0 0 0 .011.109.32.32 0 0 0 .242.221l.893.164a.32.32 0 0 1 .236.2.3.3 0 0 1 .018.085 5.4 5.4 0 0 0 .542 2.076.3.3 0 0 1-.042.333.3.3 0 0 1-.038.037l-.838.693a.31.31 0 0 0-.062.409l.017.026.716 1.088a.316.316 0 0 0 .414.1m6.831-7.065a3.7 3.7 0 0 1 .42.53 2.85 2.85 0 0 1 .39 1.5c0 .048-.008.1-.012.143a2.948 2.948 0 0 1-5.88.03 2 2 0 0 1 0-.286 3.4 3.4 0 0 1 .275-1.106 2.927 2.927 0 0 1 4.808-.815",
    "data-name": "Path 15289"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9656",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9655"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_svg__d)",
    "data-name": "Group 9654",
    transform: "translate(173.838 126.873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "m2.603 14.87 1.534-.831a.39.39 0 0 1 .4.025q.227.16.47.3a6.5 6.5 0 0 0 .924.453.38.38 0 0 1 .245.354l.021 1.823a.374.374 0 0 0 .349.371l1.662.125a.37.37 0 0 0 .391-.3l.306-1.651a.37.37 0 0 1 .325-.305 6.7 6.7 0 0 0 2.039-.6.384.384 0 0 1 .456.1l.649.788a.39.39 0 0 0 .507.077l1.381-.913a.3.3 0 0 0 .075-.064.37.37 0 0 0 .05-.43l-.62-1.146-.151-.279a6.8 6.8 0 0 0 1.069-1.915.37.37 0 0 1 .347-.249l1.469-.015a.385.385 0 0 0 .38-.357l.1-1.271.026-.364a.39.39 0 0 0-.317-.414l-1.379-.257a.37.37 0 0 1-.306-.313 6.7 6.7 0 0 0-.365-1.383 1 1 0 0 0-.042-.113.2.2 0 0 1-.013-.038.38.38 0 0 1 .127-.4l1.278-1.057a.3.3 0 0 0 .04-.038.39.39 0 0 0 .036-.467l-.908-1.378a.385.385 0 0 0-.5-.127l-1.6.868a.37.37 0 0 1-.419-.041 7 7 0 0 0-.85-.59q-.241-.142-.489-.261a.39.39 0 0 1-.221-.349l-.02-1.752a.375.375 0 0 0-.346-.369L9.068-.005a.39.39 0 0 0-.415.319L8.41 1.62a.384.384 0 0 1-.355.315 6.7 6.7 0 0 0-2.028.425.38.38 0 0 1-.434-.114l-.952-1.152a.4.4 0 0 0-.52-.078l-1.373.9a.38.38 0 0 0-.124.5l.035.067.721 1.331a.39.39 0 0 1-.048.438 6.7 6.7 0 0 0-.688.964 8 8 0 0 0-.3.565.38.38 0 0 1-.34.222l-1.491.015a.39.39 0 0 0-.387.362L.004 8.017a.4.4 0 0 0 .014.134.39.39 0 0 0 .3.273l1.1.2a.39.39 0 0 1 .291.249.4.4 0 0 1 .022.106 6.7 6.7 0 0 0 .67 2.563.38.38 0 0 1-.052.411.4.4 0 0 1-.047.045l-1.035.855a.384.384 0 0 0-.076.505l.021.032.883 1.344a.39.39 0 0 0 .511.126m8.435-8.724a4.5 4.5 0 0 1 .518.654 3.5 3.5 0 0 1 .482 1.858c0 .059-.01.118-.016.176a3.639 3.639 0 0 1-7.261.037 2.4 2.4 0 0 1 0-.353 4.1 4.1 0 0 1 .34-1.366 3.614 3.614 0 0 1 5.937-1.006",
    "data-name": "Path 15290"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m185.515 125.847.821-.445a.21.21 0 0 1 .215.013q.121.085.252.162a3.5 3.5 0 0 0 .494.242.2.2 0 0 1 .131.189l.011.975a.2.2 0 0 0 .187.2l.889.067a.2.2 0 0 0 .208-.161l.164-.883a.2.2 0 0 1 .174-.163 3.6 3.6 0 0 0 1.091-.32.205.205 0 0 1 .244.055l.347.422a.21.21 0 0 0 .271.041l.739-.488a.2.2 0 0 0 .04-.034.2.2 0 0 0 .027-.23l-.332-.613-.081-.149a3.5 3.5 0 0 0 .286-.416 3.6 3.6 0 0 0 .286-.609.2.2 0 0 1 .186-.133l.786-.008a.206.206 0 0 0 .2-.191l.052-.68.014-.195a.21.21 0 0 0-.17-.222l-.738-.138a.2.2 0 0 1-.164-.167 3.6 3.6 0 0 0-.2-.74q-.01-.03-.022-.06l-.007-.021a.2.2 0 0 1 .068-.215l.684-.566.021-.02a.21.21 0 0 0 .02-.25l-.486-.737a.206.206 0 0 0-.27-.068l-.856.464a.2.2 0 0 1-.224-.022 4 4 0 0 0-.455-.316q-.129-.076-.262-.14a.21.21 0 0 1-.118-.187l-.011-.937a.2.2 0 0 0-.185-.2l-.88-.065a.21.21 0 0 0-.222.171l-.13.7a.205.205 0 0 1-.19.168 3.6 3.6 0 0 0-1.085.228.2.2 0 0 1-.232-.061l-.509-.616a.21.21 0 0 0-.278-.042l-.734.483a.2.2 0 0 0-.067.266l.019.036.386.712a.21.21 0 0 1-.026.234 3.6 3.6 0 0 0-.368.516q-.086.15-.159.3a.2.2 0 0 1-.182.119l-.8.008a.21.21 0 0 0-.207.194l-.065.876a.2.2 0 0 0 .007.072.21.21 0 0 0 .16.146l.59.108a.21.21 0 0 1 .156.133.2.2 0 0 1 .012.057 3.6 3.6 0 0 0 .358 1.371.2.2 0 0 1-.028.22l-.025.024-.554.458a.205.205 0 0 0-.041.27l.011.017.473.719a.21.21 0 0 0 .273.067m4.512-4.667a2.4 2.4 0 0 1 .277.35 1.9 1.9 0 0 1 .258.994q-.002.048-.008.094a1.947 1.947 0 0 1-3.884.02 1 1 0 0 1 0-.189 2.2 2.2 0 0 1 .182-.731 1.933 1.933 0 0 1 3.176-.538",
    "data-name": "Path 15291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "m48.935 126.013.9-.488a.23.23 0 0 1 .236.015q.133.094.276.178a4 4 0 0 0 .542.266.22.22 0 0 1 .144.207l.012 1.069a.22.22 0 0 0 .2.218l.975.074a.22.22 0 0 0 .229-.176l.18-.968a.22.22 0 0 1 .191-.179 4 4 0 0 0 1.2-.351.225.225 0 0 1 .268.06l.381.462a.23.23 0 0 0 .3.045l.81-.535a.2.2 0 0 0 .044-.038.22.22 0 0 0 .029-.252l-.363-.672-.089-.164a4 4 0 0 0 .313-.456 4 4 0 0 0 .314-.668.22.22 0 0 1 .2-.146l.861-.009a.226.226 0 0 0 .223-.209l.056-.745.016-.214a.23.23 0 0 0-.186-.243l-.809-.151a.22.22 0 0 1-.18-.183 4 4 0 0 0-.214-.811l-.025-.066-.008-.023a.22.22 0 0 1 .074-.236l.75-.62.024-.022a.23.23 0 0 0 .021-.274l-.532-.808a.226.226 0 0 0-.3-.074l-.938.509a.22.22 0 0 1-.246-.024 4 4 0 0 0-.5-.346q-.141-.083-.287-.153a.23.23 0 0 1-.13-.2l-.012-1.028a.22.22 0 0 0-.2-.216l-.965-.071a.23.23 0 0 0-.243.187l-.142.766a.225.225 0 0 1-.208.184 4 4 0 0 0-1.19.25.22.22 0 0 1-.255-.067l-.559-.676a.23.23 0 0 0-.3-.046l-.805.53a.22.22 0 0 0-.073.291l.021.04.423.781a.23.23 0 0 1-.028.257 4 4 0 0 0-.4.565 4 4 0 0 0-.174.331.22.22 0 0 1-.2.13l-.874.009a.23.23 0 0 0-.227.212l-.072.961a.3.3 0 0 0 .008.079.23.23 0 0 0 .175.16l.646.119a.23.23 0 0 1 .171.146.2.2 0 0 1 .013.062 3.9 3.9 0 0 0 .393 1.5.22.22 0 0 1-.03.241l-.027.027-.607.5a.225.225 0 0 0-.045.3l.012.019.518.788a.23.23 0 0 0 .3.074m4.947-5.117a2.6 2.6 0 0 1 .3.384 2.07 2.07 0 0 1 .283 1.09c0 .035-.006.069-.009.1a2.135 2.135 0 0 1-4.259.022 1.4 1.4 0 0 1 0-.207 2.4 2.4 0 0 1 .2-.8 2.12 2.12 0 0 1 3.482-.59",
    "data-name": "Path 15292"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9659",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9658"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_svg__e)",
    "data-name": "Group 9657",
    transform: "translate(125.269 85.457)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "m5.728 25.493 2.312-1.655a.63.63 0 0 1 .656-.041q.4.213.823.4a10.6 10.6 0 0 0 1.586.546.62.62 0 0 1 .467.523l.4 2.944a.61.61 0 0 0 .64.53l2.714-.134a.6.6 0 0 0 .571-.565l.161-2.731a.61.61 0 0 1 .465-.56 11 11 0 0 0 3.177-1.38.626.626 0 0 1 .759.074l1.21 1.144a.63.63 0 0 0 .835.022l2.048-1.755a.6.6 0 0 0 .109-.119.61.61 0 0 0-.006-.706l-1.234-1.729-.3-.421a11 11 0 0 0 .707-1.364 11 11 0 0 0 .635-1.949.61.61 0 0 1 .511-.472l2.372-.321a.63.63 0 0 0 .543-.655l-.1-2.075-.031-.594a.636.636 0 0 0-.6-.606l-2.283-.137a.605.605 0 0 1-.558-.444 11 11 0 0 0-.871-2.163 2 2 0 0 0-.091-.174.3.3 0 0 1-.028-.06.62.62 0 0 1 .123-.677l1.853-1.968a.5.5 0 0 0 .057-.07.63.63 0 0 0-.036-.762l-1.747-2.044a.63.63 0 0 0-.841-.1l-2.411 1.727a.61.61 0 0 1-.687.018 11 11 0 0 0-1.494-.783q-.419-.181-.844-.323a.64.64 0 0 1-.428-.519l-.388-2.83a.61.61 0 0 0-.634-.527l-2.684.136a.637.637 0 0 0-.607.6l-.128 2.161a.626.626 0 0 1-.511.581 11 11 0 0 0-3.194 1.1.62.62 0 0 1-.725-.1l-1.773-1.67a.644.644 0 0 0-.856-.021L3.334 4.534a.615.615 0 0 0-.1.828l.071.1L4.74 7.47a.63.63 0 0 1 .011.718 11 11 0 0 0-.919 1.7 12 12 0 0 0-.366.974.62.62 0 0 1-.505.427l-2.408.326a.64.64 0 0 0-.553.664l.134 2.673a.7.7 0 0 0 .05.214.64.64 0 0 0 .538.381l1.824.1a.64.64 0 0 1 .521.343.7.7 0 0 1 .057.166 10.9 10.9 0 0 0 1.6 4.009.62.62 0 0 1 0 .675 1 1 0 0 1-.066.083l-1.5 1.592a.625.625 0 0 0-.021.832l.04.048 1.7 1.994a.636.636 0 0 0 .852.1M17.604 9.673a7.3 7.3 0 0 1 .971.953 5.74 5.74 0 0 1 1.155 2.907c.006.1.008.193.011.288A5.932 5.932 0 0 1 8.005 15.35a4 4 0 0 1-.071-.571 6.8 6.8 0 0 1 .273-2.278 5.89 5.89 0 0 1 9.4-2.828",
    "data-name": "Path 15293"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "M59.237 106.044c.724-3.671 6.882-2.971 6.882-2.971s4.569 6.016 5.781 6.082-2.9-5.906-2.9-5.906c2.311-.388 8.44 2.049 8.44 2.049s.139 7.382 1.33 7.147-.457-6.53-.457-6.53c2.3.518 4.584 3 4.584 3 2.926 4.094-2.482 7.64-2.482 7.64a12 12 0 0 0 1.885 5.374 8.7 8.7 0 0 1 .819 1.409l-.614.043q-.093-.242-.2-.465v-.006l-.205-.382a12 12 0 0 1-.453-.807 9.4 9.4 0 0 0-2.119-2.835 1.2 1.2 0 0 0 .112-.291l-.112.291c-.893 2.325-6.121 3.068-9.09 2.673s-1.751-1.31-.269-2.761 4.809-1.328 5.748-1.922-.524-1.019-2.465-.733-2.78 2.306-5.911 2.827-5.948-5.24-5.948-5.24c2.224.523 6.043-.951 6.14-1.712s-5.676-.281-6.593-.444-2.619-1.853-1.895-5.524",
    "data-name": "Path 15294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66767c",
    d: "m108.839 120.008-3.257 38.729s-.341 2.348 1.405 2.352c2.871.007 14.291 0 14.291 0s-2.161-.489-2.135-1.588c.031-1.3 3.807-39.859 3.807-39.859Z",
    "data-name": "Path 15295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M122.203 160.386c-.565 0-11.472.036-14.268 0-1.219-.015-1.432-1.083-1.442-1.775a3.5 3.5 0 0 1 .037-.576l.085-1.007.216-2.566.191-2.267.245-2.913.206-2.458 2.314-27.519 14.111-.366s-1.59 16.138-2.715 27.886c-.125 1.309-.245 2.564-.355 3.735q-.054.561-.1 1.1c-.1 1.111-.2 2.132-.283 3.033l-.121 1.321c-.144 1.584-.228 2.6-.229 2.788a1.6 1.6 0 0 0 .028.313c.232 1.234 1.872 1.275 2.084 1.275",
    "data-name": "Path 15296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m74.569 98.933 7.934 31.869 1.086 4.365 3.7 14.844h68.651l-13.62-51.077Z",
    "data-name": "Path 15297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "m74.569 98.933-1.1.367 12.353 51.819 1.462-1.109Z",
    "data-name": "Path 15298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "M85.822 151.119h68.23l1.884-1.108H87.284Z",
    "data-name": "Path 15299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M109.782 160.401h14.773v.702h-14.773z",
    "data-name": "Rectangle 2862"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m120.8 151.118-.076.537-13.893 2.807.191-2.267.091-1.077Z",
    "data-name": "Path 15300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M122.204 160.385c-.565 0-11.472.036-14.268 0-1.219-.015-1.432-1.083-1.442-1.775l13.827-2.6c-.144 1.584-.228 2.6-.229 2.788a1.6 1.6 0 0 0 .028.313c.232 1.234 1.872 1.275 2.084 1.275",
    "data-name": "Path 15301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66767c",
    d: "m117.442 139.671-30.158 10.34-3.7-14.844Z",
    "data-name": "Path 15302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M74.569 98.933h67.743l10.909 41.05H84.792Z",
    "data-name": "Path 15303"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9662",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9661"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_svg__f)",
    "data-name": "Group 9660",
    transform: "translate(77.299 100.392)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dce2e5",
    d: "m0 0 9.732 37.394h62.912L62.806.43Z",
    "data-name": "Path 15304"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#d3444b",
    d: "M100.073 122.77h23.797v15.015h-23.797z",
    "data-name": "Rectangle 2864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M111.971 122.77h23.796v15.014h-23.796z",
    "data-name": "Rectangle 2865"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba454b",
    d: "m111.971 124.988-5.014 5.013h-6.868v-7.234h11.884Z",
    "data-name": "Path 15305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m100.073 122.77-5.35 5.163h11.906l5.343-5.163Z",
    "data-name": "Path 15306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba454b",
    d: "m135.767 123.302-23.8-.532v2.211l4.425 4.851h19.371v-4.829l-.123-.144h.123Z",
    "data-name": "Path 15307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m111.971 122.77 4.708 5.163h23.481l-4.394-5.163Z",
    "data-name": "Path 15308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M70.505 120.87a1.658 1.658 0 0 0-1.849-1.8 2.4 2.4 0 0 1 .926.5 2.38 2.38 0 0 0-2.683.4c-1.4 1.159-.529 4.066-.955 4.618s-2.081.662-1.879 2.447 5.255 4.02 4.931 5.5c0 0 1.98-2.911.564-4.24a2.63 2.63 0 0 1 .76 1.423s.187-1.509-.773-1.991a3.54 3.54 0 0 1-1.472-2.268c.074-.279 2.429-4.585 2.429-4.585",
    "data-name": "Path 15309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M68.522 129.527s1.505 6.227 2.983 7.472c.888.748 3.529 2.465 3.529 2.465l-1.1.4s-3.663-1.237-4.482-2.2a51 51 0 0 1-3.065-5.795Z",
    "data-name": "Path 15310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m77.184 141.74-.354-.876a2.485 2.485 0 0 0-2.3-1.554h-6.525v21.815h26.991v-17.676H79.719a2.73 2.73 0 0 1-2.535-1.71",
    "data-name": "Path 15311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.077 152.576v-1.573l5.516-2.416v1.607l-3.852 1.584 3.852 1.584v1.63Z",
    "data-name": "Path 15312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.322 146.707h1.47l-5.048 10.553h-1.47Z",
    "data-name": "Path 15313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.923 151.004v1.573l-5.516 2.416v-1.607l3.852-1.584-3.852-1.584v-1.63Z",
    "data-name": "Path 15314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m54.375 140.466.041.073c.329.573 1.085 1.975 1.917 3.51.394.728.806 1.487 1.2 2.2.674 1.231 1.287 2.328 1.644 2.907s.631 1 .74 1.169a.27.27 0 0 1 .035.171 9 9 0 0 0 .024 1.544 11.84 11.84 0 0 0 3.869 7.67l1 .148s-1.417-5.249-1.834-8.217a5.7 5.7 0 0 1-.077-1.177 12.3 12.3 0 0 0-.323-3.212 72 72 0 0 0-2.052-7.433c-.047-.145-1.455-5.239-1.455-5.239-1.182 1.033-5.492 1.459-5.492 1.459s-.731 1.777.759 4.427",
    "data-name": "Path 15315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M66.947 161.125h-4.179a2.3 2.3 0 0 1 .118-1.12c.209-.464.507-.478.038-1.205a2.55 2.55 0 0 0 1.723.305 5.1 5.1 0 0 0 .724 1.1c.273.2 1.491.126 1.575.917",
    "data-name": "Path 15316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "m54.376 140.466.041.073c.329.573 2.111 3.863 2.943 5.4a22.3 22.3 0 0 1-.294-7.935Z",
    "data-name": "Path 15317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M69.935 120.616a17 17 0 0 0-2.509 1.227c-1.132 1.256-.809 2.895-.161 2.91.415.01.335.7.335.7l4.629-1.958s-.557-3.25-2.293-2.88",
    "data-name": "Path 15318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M68.38 128.596a5.9 5.9 0 0 1 .616 2.549 4.43 4.43 0 0 1-3.052 1.68s1.894-4.23 2.436-4.229",
    "data-name": "Path 15319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m57.638 136.35.014-.781c-1.557.2-5.369-1.861-5.369-1.861s-1.629 1.084-1.852 4.178c-.109 1.51-.8 7.9-.874 9.805a55 55 0 0 0-.04 1.382.27.27 0 0 1-.066.161 9 9 0 0 0-.844 1.293c-2.376 4.421-1.134 10.428-1.134 10.428l.552-.14s2.009-6.228 3.322-8.921a5.6 5.6 0 0 1 .595-1.018 12.3 12.3 0 0 0 1.528-2.844c.97-2.317 4.168-11.684 4.168-11.684",
    "data-name": "Path 15320"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M50.792 161.126h-4.179a2.3 2.3 0 0 1 .118-1.12c.209-.464.537-.674.458-1.235a1.5 1.5 0 0 0 1.3.5 4.6 4.6 0 0 0 .725.94c.273.2 1.491.126 1.575.917",
    "data-name": "Path 15321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M65.662 133.719c-.561.1.092.542-.68.626a14 14 0 0 0-2.828.439.64.64 0 0 0-.407.33 7.9 7.9 0 0 1-1.889 2.106c-7.277-.331-7.745-3.574-7.745-3.574 4.723-4.587 8.74-7.087 12.061-7.4a5.9 5.9 0 0 1 2.409.253 4.33 4.33 0 0 1 1.8 2.09s-.585 4.763-2.718 5.126",
    "data-name": "Path 15322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "M64.981 134.345a14 14 0 0 0-2.828.439 11.6 11.6 0 0 1 1.47-6.359s1.117 4.547 1.358 5.92",
    "data-name": "Path 15323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M65.929 127.81s-2.763-.151-3.254 1.584.921 8.66 1.226 9.375a48 48 0 0 0 3.251 5.015l.992-.3s-1.8-5.673-2.2-6.235c-.63-.881.813-8.682-.014-9.436",
    "data-name": "Path 15324"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M68.143 143.482a1.6 1.6 0 0 0 .237.667c.186.227.727.777.736 1.1 0 0-.027.143-.143.117s-.519-.425-.725-.4a4 4 0 0 0 .22.826 2.4 2.4 0 0 1-.043 1.108c-.066.157-.872-.841-1.2-1.287s-.005-2.254-.005-2.254Z",
    "data-name": "Path 15325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M62.13 131.714a7.7 7.7 0 0 0 4.246-.348s1.363-4.269-.585-4.064-3.1.818-3.149 1.75a18 18 0 0 1-.512 2.663",
    "data-name": "Path 15326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M66.52 126.801c.208.651.9 2.5 1.86 1.791a2.4 2.4 0 0 1 .407-.949c.3-.522.666-1.056.666-1.056l-1.564-1.37-.093-.082a4 4 0 0 1-1.163 1.321.31.31 0 0 0-.112.345",
    "data-name": "Path 15327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed985f",
    d: "M69.452 126.588s-.361.532-.665 1.055a2.42 2.42 0 0 1-.9-2.426Z",
    "data-name": "Path 15328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M69.495 127.275s-2.36-1.313-1.52-2.771 1.1-2.608 2.645-1.831 1.512 1.5 1.35 2.055-1.839 2.851-2.475 2.547",
    "data-name": "Path 15329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M72.368 123.877c-.108-.647-.437-.709-.666-.666a1.89 1.89 0 0 0-2.3-.879 3.2 3.2 0 0 1-1.86 1.117s.274.51 1.4.825a1.93 1.93 0 0 0 1.113-.089 6.3 6.3 0 0 1-1.6.6 4.5 4.5 0 0 0 3.049-1.369 2.1 2.1 0 0 1 .117.974c-.1.438-.487 1.232-.249 1.335 0 0 1.154-.882.992-1.853",
    "data-name": "Path 15330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M75.464 139.467s-.659.494-.162.817 1.383.41 1.386.2c.012-.711-.342-1.217-1.224-1.015",
    "data-name": "Path 15331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M198.403 161.505H29.14a.18.18 0 0 1-.182-.182v-.038a.18.18 0 0 1 .182-.182h169.263a.18.18 0 0 1 .182.182v.038a.18.18 0 0 1-.182.182",
    "data-name": "Path 15332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M84.998 112.351c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m80.762 104.153-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M81.622 104.462c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m100.928 104.117-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M101.785 104.425c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15337"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M103.253 104.423c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15338"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M110.747 104.425c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M112.212 104.423c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15340"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M113.677 104.42c-.076-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M123.864 104.395c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15342"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M125.266 104.393c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M126.792 104.39c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M129.283 104.386c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m130.86 104.074-.181.047-.1-.2.294-.094h.166l.266 1.1h-.239Z",
    "data-name": "Path 15346"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M131.72 104.382c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M134.161 104.37c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M91.906 106.82c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15349"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M93.371 106.819c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15350"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M129.858 106.761c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m131.435 106.447-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M132.295 106.762c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15353"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M137.665 106.745c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15354"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m139.245 106.432-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M90.673 119.641c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M92.138 119.638c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m93.716 119.325-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15358"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M96.041 119.632c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15359"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M97.506 119.629c-.076-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15360"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M98.972 119.627c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15361"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M117.264 119.641c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M118.729 119.638c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m120.304 119.325-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M127.088 119.641c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.061.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15365"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M128.551 119.638c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m130.13 119.325-.181.047-.1-.2.294-.094h.165l.266 1.1h-.239Z",
    "data-name": "Path 15367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M122.632 119.632c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M124.097 119.629c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M125.562 119.627c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15370"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M103.983 119.597c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.348-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m105.557 119.289-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M106.42 119.598c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.061.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15373"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M135.402 119.568c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15374"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m136.979 119.255-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M137.839 119.563c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.326.347.2-.147.155-.348",
    "data-name": "Path 15376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m82.005 109.287-.181.047-.1-.2.294-.094h.166l.266 1.1h-.239Z",
    "data-name": "Path 15377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M82.865 109.595c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15378"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M91.163 109.581c-.077-.317.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15379"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M92.628 109.578c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15380"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M94.094 109.58c-.076-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15381"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m95.672 109.263-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m96.652 109.261-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M97.511 109.569c-.076-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M135.404 109.508c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M136.87 109.506c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.061.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M138.335 109.504c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15387"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m139.913 109.191-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m82.673 112.045-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M83.533 112.353c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15390"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M90.366 112.342c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15391"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M91.832 112.339c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M86.274 117.679c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "m87.852 117.367-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m83.281 114.615-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M84.141 114.923c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M85.607 114.921c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m87.184 114.608-.181.047-.1-.2.294-.094h.166l.266 1.1h-.239Z",
    "data-name": "Path 15398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M88.044 114.921c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15399"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M89.509 114.914c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M90.974 114.912c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M92.439 114.909c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M93.904 114.907c-.076-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M95.37 114.905c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15404"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m96.948 114.592-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15405"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m97.928 114.59-.181.047-.1-.2.294-.094h.165l.266 1.1h-.232Z",
    "data-name": "Path 15406"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M98.788 114.901c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m83.949 117.373-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M84.809 117.678c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M88.713 117.679c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15410"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M90.177 117.673c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15411"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M87.57 123.796c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m89.148 123.483-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m85.245 123.489-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M86.105 123.798c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M90.007 123.792c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M91.473 123.789c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M85.76 125.763c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15418"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m87.337 125.451-.181.047-.1-.2.294-.094h.166l.266 1.1h-.233Z",
    "data-name": "Path 15419"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M88.197 125.759c-.077-.317.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15420"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M89.662 125.757c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15421"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M91.642 117.67c-.076-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M93.108 117.668c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M89.43 130.913c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.146-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "m91.009 130.6-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m86.438 127.848-.181.047-.1-.2.294-.094h.165l.266 1.1h-.233Z",
    "data-name": "Path 15426"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M87.297 128.159c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15427"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M88.763 128.154c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.146-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m90.34 127.841-.181.047-.1-.2.294-.094h.166l.266 1.1h-.239Z",
    "data-name": "Path 15429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m87.106 130.606-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15430"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M87.965 130.918c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M91.868 130.909c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15432"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M93.333 130.906c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15433"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M89.996 132.86c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "m91.574 132.547-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15435"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M88.531 132.863c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M92.434 132.856c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M93.899 132.852c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.146-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M94.798 130.904c-.076-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M96.268 130.901c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.348.327.347.2-.147.156-.348",
    "data-name": "Path 15440"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m135.213 111.959-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M136.072 112.267c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M137.537 112.265c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M139.003 112.257c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m140.581 111.95-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M133.635 114.902c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m135.213 114.589-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M136.072 114.898c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M137.537 114.895c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.565-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "M139.003 114.889c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15450"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "m140.581 114.58-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m140.282 129.778-.181.047-.1-.2.294-.094h.165l.266 1.1h-.24Z",
    "data-name": "Path 15452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M141.144 130.09c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.061.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M142.607 130.088c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.156.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m138.843 131.57-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15455"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M139.703 131.878c-.077-.317.062-.565.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.69.69 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.145-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15456"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M141.168 131.876c-.077-.316.062-.565.355-.565a.69.69 0 0 1 .625.563c.076.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.146-.155.348.18.347.327.347.2-.147.155-.348",
    "data-name": "Path 15457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "M144.073 130.085c-.077-.316.062-.564.355-.565a.69.69 0 0 1 .625.563c.077.316-.06.564-.355.565a.686.686 0 0 1-.625-.563m.731 0c-.048-.2-.182-.347-.327-.347s-.2.146-.155.348.18.347.327.347.2-.147.156-.348",
    "data-name": "Path 15458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94b0ed",
    d: "m145.651 129.772-.181.047-.1-.2.294-.094h.166l.266 1.1h-.24Z",
    "data-name": "Path 15459"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M165.406 117.399a3.01 3.01 0 0 1 2.613 1.211c.817 1.116.251 2.431 2.295 3.445s1.75 2.292 1.341 3.9-2.122 3.542-4.166 3.447-5.538-4.3-5.412-5.712.733-1.579.251-2.512c-.754-1.461.644-3.543 3.077-3.774",
    "data-name": "Path 15460"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m166.206 124.091.015-.024c-.226-.081-.246-.411-.036-1.787l-.108.005-1.824.087s-.043.564-.12 1.089c-.015.1-.032.208-.05.3-1.373 1.367 1.582 1.985 2.123.325",
    "data-name": "Path 15461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M162.478 161.104h3.941a2.17 2.17 0 0 0-.112-1.056c-.2-.437-.5-.707-.532-1.042a1.18 1.18 0 0 1-1.128.347 4.3 4.3 0 0 1-.684.886c-.257.185-1.406.119-1.485.865",
    "data-name": "Path 15462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M167.104 144.994a5.3 5.3 0 0 0-.561 2.456 2 2 0 0 0 .044.237c1.293 5.171-.54 11.9-.54 11.9a8 8 0 0 1-.835.143c-.621.055-.712-.13-.712-.13s-.617-5.491-2.614-15.988a29 29 0 0 1-.505-3.7c-.031-.4-.062-.853-.095-1.379-.091-1.415.124-3.8 1.186-4.421.483-.286 1.14-.207 2.024.489.07.055.136.121.214.177 5.43 3.909 3.515 7.445 2.393 10.21",
    "data-name": "Path 15463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M166.543 147.45c-.061-.213-2.014-7.037-2.047-7.555-.071-1.115 2.51 1.964 2.608 5.1a5.3 5.3 0 0 0-.561 2.456",
    "data-name": "Path 15464"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "m180.362 152.809-1.64-3.583a2.16 2.16 0 0 0-.914.541c-.316.361-.544.3-1.263-.2a4 4 0 0 1 .475 1.214 7.3 7.3 0 0 0 1.653.944c.307.08.978 1.325 1.689 1.086",
    "data-name": "Path 15465"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M163.165 135.69s3.531 12.277 4.826 13.067 7.691 2.362 9.581 2.739a3.7 3.7 0 0 0-.031-1.027 5 5 0 0 0-.217-.527s-3.359-3.361-6.642-3.832c-.688-.1.276-10.834-4.387-11.255-4.26-.385-3.128.834-3.128.834",
    "data-name": "Path 15466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M157.93 116.37s.079-.394.168-.694a2.16 2.16 0 0 0-.425-1.113c-.19-.107-.684.48-.544.932.072.232.19.986.19.986Z",
    "data-name": "Path 15467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M174.236 117.101c.024.05.058.139.088.223v-.068a2.6 2.6 0 0 1 .881-1.132c.256-.057.618.794.3 1.264-.164.241-.661 1.1-.661 1.1l-.549-.332a.77.77 0 0 0-.152-.419 3 3 0 0 1-.1-.734s.11-.088.2.1",
    "data-name": "Path 15468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M164.252 122.372s-.042.564-.119 1.089a2.13 2.13 0 0 0 1.944-1.177Z",
    "data-name": "Path 15469"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M166.419 122.055a5.7 5.7 0 0 0 .946-1.551 1.965 1.965 0 0 0-1.871-2.6 2.8 2.8 0 0 0-1.207.262c-.484.232-1.216.779-.767 2.647l.1.622Z",
    "data-name": "Path 15470"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M163.766 122.816s2.542.421 2.781-1.166.726-2.6-.887-2.938-2.02.222-2.228.733-.32 3.221.335 3.372",
    "data-name": "Path 15471"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M164.25 118.49s.676 1.977 1.706 2.411a2.13 2.13 0 0 0 1.537.217 3.07 3.07 0 0 1-.725-1.939s-1.859-1.5-2.517-.689",
    "data-name": "Path 15472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M164.656 118.677a1.9 1.9 0 0 0-.885.626 3.25 3.25 0 0 0-.492 1.242s-.337-1.344.36-1.972c.74-.666 1.017.1 1.017.1",
    "data-name": "Path 15473"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M174.945 118.497s-.558 4.56-1.736 5.65c-.817.756-3.71 1.977-4.4 3.1a3.7 3.7 0 0 0-.262 1.08 19 19 0 0 0 .785 8.123q.073.225.157.45a.76.76 0 0 1-.453.987 13 13 0 0 1-2.13.557q-.251.044-.516.077a8.43 8.43 0 0 1-4.9-.682 1.11 1.11 0 0 1-.608-1.053c.05-.9.5-1.79.7-3.954.154-1.642-.967-3.957-.906-4.83a7.6 7.6 0 0 0 .021-2.116c-1.154-1.584-3.094-3.1-3.392-4.549a25.8 25.8 0 0 1-.122-5 2 2 0 0 1 .538-.136.8.8 0 0 1 .558.3s.866 3.242.909 3.461c.23 1.163 2.442 2.848 3.113 3.187a5.3 5.3 0 0 0 1.781.613s-.545.942.262 1.073c.972.157 1.722-.959 1.722-.959a4.4 4.4 0 0 0 1.653.009c.882-.129 4.02-1.19 4.473-2 .331-.586 2.073-3.833 2.073-3.833a.45.45 0 0 1 .422.041.48.48 0 0 1 .258.4",
    "data-name": "Path 15474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.504 121.955s-.109.219-.255.223a1.7 1.7 0 0 1-.543-.069 2 2 0 0 1-.087-.267 2.5 2.5 0 0 1 .885.113",
    "data-name": "Path 15475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M169.331 136.451s-2.183-.374-2.327-1.927c-.154-1.655 1.541-6.2 1.541-6.2a19 19 0 0 0 .785 8.123",
    "data-name": "Path 15476"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m164.012 98.232-.227-.834a2.27 2.27 0 0 0-1.927-1.66l-5.931-.7-.445 3.764-1.9 16.067 24.535 2.9 1.9-16.067-13.884-1.64a2.5 2.5 0 0 1-2.121-1.827",
    "data-name": "Path 15477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m158.203 107.533.169-1.43 5.273-1.6-.173 1.461-3.671 1.026 3.332 1.853-.175 1.481Z",
    "data-name": "Path 15478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m169.057 103.406 1.336.158-5.722 9.05-1.336-.158Z",
    "data-name": "Path 15479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m175.506 108.127-.169 1.43-5.273 1.6.173-1.461 3.671-1.026-3.331-1.853.175-1.481Z",
    "data-name": "Path 15480"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M174.095 117.617a4.6 4.6 0 0 0-.135-.75c-.063-.118.094-.152.228.118s.4.189.534.456.016.338-.149.322a2.4 2.4 0 0 1-.478-.146",
    "data-name": "Path 15481"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M157.974 116.165s.36-.389.358-.563.251-.605.181-.684-.2.047-.263.165-.342.111-.4.432a1.06 1.06 0 0 0 .129.649",
    "data-name": "Path 15482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "m101.012 114.167 9.317 4.081v-3.631l-4.854-2 4.854-2v-3.6l-9.317 4.081Z",
    "data-name": "Path 15483"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "m118.894 104.513-8.051 16.828h3.4l8.05-16.828Z",
    "data-name": "Path 15484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M122.92 107.032v3.631l4.854 2-4.854 2v3.6l9.317-4.081v-3.059Z",
    "data-name": "Path 15485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M110.844 120.38h3.403v.961h-3.403z",
    "data-name": "Rectangle 2866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c3a64",
    d: "M120.707 103.553h1.59v.961h-1.59z",
    "data-name": "Rectangle 2867"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m101.012 113.207 9.317 4.081v-3.631l-4.854-2 4.854-2v-3.6l-9.317 4.081Z",
    "data-name": "Path 15486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m118.894 103.553-8.051 16.828h3.4l8.05-16.828Z",
    "data-name": "Path 15487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M122.92 106.067v3.631l4.854 2-4.854 2v3.6l9.317-4.081v-3.059Z",
    "data-name": "Path 15488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M153.262 139.983h-.568l-4.644-17.72-5.97-22.779H75.407l10.1 40.5-.721.007-10.221-41.057 67.981-.059.059.227 5.968 22.9Z",
    "data-name": "Path 15489"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m153.366 140.378-.548.073-4.767-18.189.527-.26Z",
    "data-name": "Path 15490"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M84.939 109.021a.44.44 0 0 0-.079.472 2.94 2.94 0 0 0 .928 1.018q.084.067.149.124l.033.03.026.023c.408.376.254.462.987 1.225.835.869 1.41.885 1.574.806.138-.068-.143-.528-.454-1.047l-.045-.076-.124-.208c-.365-.623-.271-.916-.185-1.844.07-.754 1.173-4.213 1.173-4.213l-1.6-.276s-.482 2.754-1.013 3.178c-.284.226-.6.229-.875.4l-.057.036a2 2 0 0 0-.438.352",
    "data-name": "Path 15491"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M84.939 109.025a.44.44 0 0 0-.079.472 3.4 3.4 0 0 0 .929 1.014c.055.046.1.088.147.127l.033.03.026.023c.408.376.254.462.987 1.225.835.869 1.41.885 1.574.806.138-.068-.143-.528-.454-1.047a3.56 3.56 0 0 1-1.489-1.1c-.5-.642-.838-1.466-1.181-1.944l-.057.036a2 2 0 0 0-.438.352",
    "data-name": "Path 15492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M97.845 108.025c.1.494.8.412 1.59.219s.6.036 1.72-.088 1.459-.542 1.493-.708c.031-.148-.523-.2-1.116-.268l-.225-.027a4.8 4.8 0 0 1-1.77-.872 7.1 7.1 0 0 1-1.437-1.707l-1.536.122s.806 1.224 1.118 1.756a1.86 1.86 0 0 1 .151 1.047 2 2 0 0 0 .012.525",
    "data-name": "Path 15493"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M99.435 108.244c.787-.192.6.036 1.72-.088s1.459-.542 1.493-.708c.031-.148-.523-.2-1.116-.268l-.005.011a3.16 3.16 0 0 1-1.6.5c-.76.018-1.564-.2-2.089-.191a2 2 0 0 0 .012.525c.1.494.8.412 1.59.219",
    "data-name": "Path 15494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "m91.96 98.205-1.434 3.863-1.874 5.044a3 3 0 0 1-1-.091 4.3 4.3 0 0 1-.963-.469 55 55 0 0 1 1.491-8.525 5.5 5.5 0 0 1 .835-1.807c1.505-1.779 2.942 1.984 2.942 1.984",
    "data-name": "Path 15495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "M90.505 92.07c-.941-.3-3.623.086-6.318.614l-.564-.931-5.821-.455s-1.921 4.259-.869 6.973a.984.984 0 0 0 .985.663h4.674c2.895 0 6.126-1.99 6.544-2.073.684-.137.958 1.232 1.642 2.668s6.427 6.359 6.427 6.359a5 5 0 0 0 1.248-.128 1.23 1.23 0 0 0 .536-.338s-6.369-12.671-8.49-13.355",
    "data-name": "Path 15496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M81.69 74.033a6.1 6.1 0 0 0-2.117.017c-2.215.218-2.959 2.689-2.624 4.605.309 1.769-.588 2.258-1.628 3.656-2.085 2.8-.722 5.164.923 5.773.987.365 2.357-.556 2.357-.556a64 64 0 0 0 6.061-4.392c2.923-1.144-.895-8.568-2.973-9.1",
    "data-name": "Path 15497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M82.016 82.136c.058.205-.91.582-1.65.443-.7-.13-1.475-.944-1.315-1.021.266-.126.445-.441.3-2.142l.132.015 2.226.254s.007.693.058 1.343a4.4 4.4 0 0 0 .248 1.108",
    "data-name": "Path 15498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed975d",
    d: "M81.71 79.685s.007.693.058 1.343a2.61 2.61 0 0 1-2.284-1.6Z",
    "data-name": "Path 15499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M82.17 80.266s-2.9.286-3.046-1.521-.625-2.986 1.218-3.245 2.26.4 2.456.991.121 3.653-.628 3.774",
    "data-name": "Path 15500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M81.859 75.216s-.365 2.207-2.014 2.73a2.64 2.64 0 0 1-1.748.13 4.9 4.9 0 0 0 .785-1.836.88.88 0 0 1 .589-.674c.855-.281 1.891-1.05 2.388-.351",
    "data-name": "Path 15501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2f3a",
    d: "M81.313 75.686a1.92 1.92 0 0 1 1.029.826 3.7 3.7 0 0 1 .518 1.785s.507-2.042-.232-2.8a.77.77 0 0 0-1.315.192",
    "data-name": "Path 15502"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c3cdd1",
    d: "M76.802 88.069c.052.219.1.421.132.607.059.3.1.559.128.788.088.712.062 1.134.122 1.6a4 4 0 0 0 .217.869c.12.331 3.267.626 5.057.507a2.46 2.46 0 0 0 1.156-.25c.639-.555.575.665.663-5.173.042-2.848-2.416-5.384-2.416-5.384s-.2 1.216-2.635-.231a15 15 0 0 0-1.972 3.12c-1.018 1.934-.739 2.343-.452 3.548",
    "data-name": "Path 15503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f4858",
    d: "m90.527 102.065-1.874 5.044a3 3 0 0 1-1-.091 4.3 4.3 0 0 1-.963-.469 55 55 0 0 1 1.491-8.525Z",
    "data-name": "Path 15504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "M81.859 81.633s2.509.425 2.8 1.506 2.33 7.122 2.33 7.122-1.577.538-2.166-.051-2.05-5.466-2.05-5.466Z",
    "data-name": "Path 15505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m92.087 88.869.594-.236a1.4 1.4 0 0 1 .55-.019c.193.061.676.054.679.134s-.551.326-.551.326l-.017-.007c.21.476 1.261.747 1.312.922.062.212-.427.321-.694.387a1.47 1.47 0 0 1-1.24-.28c-.235-.248-.633-.589-.633-.589Z",
    "data-name": "Path 15506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.501 79.201a.5.5 0 0 0 .442.3c.321 0 .407-.048.468-.116a1 1 0 0 0 .121-.2 2.7 2.7 0 0 0-1.031.018",
    "data-name": "Path 15507"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f99746",
    d: "m86.293 88.17 6.074.464a1.9 1.9 0 0 1-.265 1.257s-5.48 1.071-6.91.524-1.269-3.127-1.269-3.127Z",
    "data-name": "Path 15508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "M77.061 89.464c.088.712.062 1.134.122 1.6 2.278.007 5.324-1.759 5.324-1.759Z",
    "data-name": "Path 15509"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#778991",
    d: "M82.507 87.807s-3.549-.106-4.147-2.123c-.657-2.216-1.393.911-1.393.911l.392 2h3.893Z",
    "data-name": "Path 15510"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m88.694 82.334-.192-.475a1.35 1.35 0 0 0-1.249-.843h-3.538v11.829H98.35v-9.584h-8.281a1.48 1.48 0 0 1-1.375-.927",
    "data-name": "Path 15511"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.922 88.209v-.848l2.99-1.31v.871l-2.088.859 2.088.859v.884Z",
    "data-name": "Path 15512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.021 85.027h.8l-2.737 5.722h-.8Z",
    "data-name": "Path 15513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.142 87.361v.853l-2.991 1.31v-.871l2.089-.859-2.089-.859v-.884Z",
    "data-name": "Path 15514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "m82.511 88.274.257-.4a2 2 0 0 0 .488-.266c.339-.238.294-.595.464-.557v.784h-.018c.727.194 1.578-.017 1.595.164.047.5-.338.722-.661.878a1.17 1.17 0 0 1-.974.16c-.326-.1-.84-.2-.84-.2Z",
    "data-name": "Path 15515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "M79.224 81.396s-2.3.151-2.88 1.049a17.6 17.6 0 0 0-.991 7.027c.3 1.567 7.677-.3 7.677-.3l-.235-1.359s-4.258.025-4.5-.53c-.323-.737.929-5.887.929-5.887",
    "data-name": "Path 15516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb27d",
    d: "M90.344 83.256a.86.86 0 0 0 .869.558c.326-.065.75-.768.378-.922a1.06 1.06 0 0 0-1.247.364",
    "data-name": "Path 15517"
  }))))))));
};
export default SvgProduct;